export default __webpack_public_path__ + "static/media/news89.3ef0f93f.jpg";